/**
 * Extension list for point cloud scans that can be ingested as a static 3D
 * asset.
 *
 * Only PLY for now: it is what mapping pipelines export, and the platform
 * converter handles vertex-only PLY specifically. PCD and LAS would slot in
 * here once the converter learns them.
 */
export const pointCloudFileTypes = ["ply"];

/** Files that can be converted into a static point cloud asset. */
export const isPointCloud = (filename: string): boolean => {
  const lower = filename.toLowerCase();
  return pointCloudFileTypes.some((ext) => lower.endsWith(`.${ext}`));
};
